<template>
				<div class="j-main">
					<div data-v-36288b80="" data-v-a5686a06="" class="j-container layout-search router j-container h5">
						<!---->
						<div data-v-dbeee98c="" data-v-36288b80="" class="hd-search-group">
							<div data-v-dbeee98c="" class="back-icon" @click="goToBack"><i data-v-991cf48f="" data-v-dbeee98c=""
									class="iconfont icon-back" ></i></div>
							<form data-v-dbeee98c="" class="search-form van-form" action="javascript: true">
								<div data-v-dbeee98c="" class="input-group van-cell van-field">
									<div class="van-field__left-icon"><i data-v-991cf48f="" data-v-dbeee98c=""
											class="iconfont icon-search"></i></div>
									<div class="van-cell__value van-cell__value--alone van-field__value">
										<div class="van-field__body">
											<input v-model="inputValue" type="search" placeholder="请输入产品或业务名称关键词" class="van-field__control">
										</div>
									</div>
								</div><button data-v-dbeee98c="" type="submit" @click="goToSearch" class="search-button clickable"> 搜索
								</button>
							</form>
						</div>
						<div data-v-36288b80="" class="j-main layout-search-content">
							<div data-v-401607c8="" data-v-a5686a06="" class="j-container search-result-bidding top-radius" data-v-36288b80="">
								<!--<div data-v-401607c8="" class="j-header linear-main-bg" style="">
									<div data-v-0a57cd64="" data-v-401607c8="" class="dropdown-menu-arrow top-radius van-dropdown-menu">
										<div   :class="['van-dropdown-menu__bar', { 'van-dropdown-menu__bar--opened': isBarOpened }]">
											<div role="button" tabindex="0" class="van-dropdown-menu__item" style="justify-content: center"   @click="toggleVisibility(1)" >
												<span  :class="['van-dropdown-menu__title', { 'van-dropdown-menu__title van-dropdown-menu__title--active van-dropdown-menu__title--down': isOpened[1] }]">
													<div class="van-ellipsis">搜索范围</div>
												</span></div>
											<div role="button" tabindex="0" class="van-dropdown-menu__item" style="justify-content: center"   @click="toggleVisibility(2)">
											<span :class="['van-dropdown-menu__title', { 'van-dropdown-menu__title van-dropdown-menu__title--active van-dropdown-menu__title--down': isOpened[2] }]">
													<div class="van-ellipsis">发布时间</div>
												</span></div>
											<div role="button" tabindex="0" class="van-dropdown-menu__item"  @click="toggleVisibility(3)">
												<span :class="['van-dropdown-menu__title', { 'van-dropdown-menu__title van-dropdown-menu__title--active van-dropdown-menu__title--down': isOpened[3] }]">
													<div class="van-ellipsis">项目地区</div>
												</span></div>
											<div role="button" tabindex="0" class="van-dropdown-menu__item"  @click="toggleVisibility(4)">
												<span :class="['van-dropdown-menu__title', { 'van-dropdown-menu__title van-dropdown-menu__title--active van-dropdown-menu__title--down': isOpened[4] }]" >
													<div class="van-ellipsis">更多筛选</div>
												</span></div>
										</div>
										<div data-v-0a57cd64=""></div>
										<div data-v-0a57cd64=""></div>
										<div data-v-0a57cd64=""></div>
										<div data-v-0a57cd64=""></div>
									</div>
									<div data-v-401607c8="" class="flex flex-justify-between tab-saved">
										<div data-v-401607c8="" class="tab-saved-left ellipsis"><span data-v-401607c8=""
												class="tab-saved-left-label">已选：</span><span data-v-401607c8=""
												class="tab-saved-left-value">精准搜索，标题/正文，最近1年</span></div>
										<div data-v-401607c8="" class="tab-saved-right"><span data-v-401607c8=""
												class="save-action">保存</span></div>
									</div>
									<div data-v-401607c8="" class="intercept-tip-container" style="display: none;"><i
											data-v-991cf48f="" data-v-401607c8="" class="iconfont icon-tishi"></i>
									</div>
								</div>-->
								<div data-v-401607c8="" class="j-main list-container">
									<div data-v-401607c8="" class="tab-search-info" style="">
										<div data-v-401607c8=""
											class="flex flex-items-center flex-justify-between tab-search-info-top">
											<div data-v-401607c8="" class="flex">
												<p data-v-401607c8="" class="search-total-count"> 搜索到<span
														data-v-401607c8="" class="highlight-text"> 265781 </span>条信息
												</p>
												<!--<div data-v-401607c8="" class="data-export clickable"><i
														data-v-991cf48f="" data-v-401607c8=""
														class="iconfont icon-shujudaochu_xiao1"></i><span
														data-v-401607c8="" class="text">导出</span></div>-->
											</div>
											<!--<div data-v-401607c8="" class="tab-right"><span data-v-401607c8=""
													class="van-popover__wrapper">
													<div data-v-401607c8="" class="selected-tab-content"><span
															data-v-401607c8="">精简</span><i data-v-401607c8=""
															class="van-icon van-icon-arrow-down"
															style="color: rgb(42, 190, 209);"></i></div>
												</span></div>-->
										</div>
										<div data-v-401607c8="" class="tip-toggle-search-mode-container"
											style="display: none;">
											<div data-v-401607c8=""> 如需查看更多相关信息，建议您切换至 <div data-v-401607c8=""
													class="tip-action highlight-text"> "模糊搜索" <i data-v-991cf48f=""
														data-v-401607c8=""
														class="iconfont search-mode-label-icon icon-help1"></i></div>
												搜索模式 按照当前条件共匹配到条公告。 <div data-v-401607c8="" class="search-model-switch">
													<span data-v-401607c8=""
														class="search-model-switch-text">立即切换查看</span><i
														data-v-991cf48f="" data-v-401607c8=""
														class="iconfont icon-youbian"
														style="color: rgb(42, 190, 209);"></i></div>
											</div>
										</div><!---->
									</div>
									<div data-v-401607c8="" role="feed" class="more-list calc-height-1px van-list">
										<div data-v-401607c8="" class="list-wrapper">
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom" @click="goToContent(1)">
												<div data-v-06a7ce78="" class="title-group" >
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">招商三亚深海装备产业园二期项目3号、6号楼<span
																class="highlight-text-orange-bd">智能化</span>工程</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">三亚市</span><span data-v-06a7ce78=""
															class="tag-item grey">制造业</span><span data-v-06a7ce78=""
															class="tag-item grey">单一</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">二期项目3号、6号楼<span
														class="highlight-text-orange-bd">智能化</span>工程
													招商三亚深海装备产业园二期项目3号、6号楼<span
														class="highlight-text-orange-bd">智能化</span>工程项目概况采购项目名称：招商三亚深海装备产业园二期项目3号、6号楼<span
														class="highlight-text-orange-bd">智能化</span>工程采购项目编号：G1100000175205179001
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">招商（三亚）深海装备产业园有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-12-01</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<div data-v-401607c8="" class="recommend-card-container"
												style="opacity: unset;"><!----></div>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">随县水利和湖泊局本级鄂北地区水资源配置工程随县配套工程电子及<span
																class="highlight-text-orange-bd">智能化</span>安装工程竞争性磋商公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">随州市</span><span
															data-v-06a7ce78="" class="tag-item grey">竞谈</span><span
															data-v-06a7ce78="" class="tag-item grey">256万元</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">程随县配套工程电子及<span
														class="highlight-text-orange-bd">智能化</span>安装工程竞争性磋商公告
													【项目概况】鄂北地区水资源配置工程随县配套工程电子及<span
														class="highlight-text-orange-bd">智能化</span>安装工程采购项目的潜在供应商应在湖北省政府采购电子交易数据汇聚平台（网址：https
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">随县水利和湖泊局</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">预算金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">256万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">开标日期</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">2024-12-13</span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-12-01</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">在役管道抢修全自动焊<span
																class="highlight-text-orange-bd">智能化</span>技术研究11月物资需求-检测器-非招标候选人公示</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">上海市</span><span data-v-06a7ce78=""
															class="tag-item grey">中标</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">在役管道抢修全自动焊<span
														class="highlight-text-orange-bd">智能化</span>技术研究11月物资需求-检测器-非招标候选人公示
													在役管道抢修全自动焊<span
														class="highlight-text-orange-bd">智能化</span>技术研究11月物资需求-检测器项目成交候选人公示在役管道抢修全自动焊<span
														class="highlight-text-orange-bd">智能化</span>技术研究11月物资需求-检测器的采购项目已结束，经依法组建的采购小组的评审
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">经营财务部</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-12-01</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom visited">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">沙坡头区淡水鱼养殖、牧草种植生态循环全产业链示范项目三标段（EPC）总承包招标公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">中卫市</span><span
															data-v-06a7ce78="" class="tag-item grey">农林牧渔</span><span
															data-v-06a7ce78="" class="tag-item grey">招标</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">计综合甲级资质、建筑<span
														class="highlight-text-orange-bd">智能化</span>系统设计专项甲级资质，并在人员、设备、资金等方面具备相应的设计能力。
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">中城生态农业科技（宁夏）有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">开标日期</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">2024-12-22</span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-12-01</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<div data-v-401607c8="" data-key="sddtnbxe-4" class="middle-list-container">
												<div data-v-4fed0739="" data-v-401607c8=""
													class="ad-container ad-container no-height-placeholder">
													<div data-v-4fed0739="" class="reveal-box van-image" style=""><img
															src="https://cdn-ali2.jianyu360.cn/qmxupload/2024/11/22/202411221540310110008TM7C.png"
															alt="" class="van-image__img">
														<div class="tag-text">广告</div>
														<div data-v-4fed0739="" class="close"><i data-v-4fed0739=""
																class="van-icon van-icon-cross"><!----></i></div>
													</div>
												</div>
											</div>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">沙坡头区淡水鱼养殖、牧草种植生态循环全产业链示范项目三标段（EPC）总承包)招标公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">中卫市</span><span
															data-v-06a7ce78="" class="tag-item grey">农林牧渔</span><span
															data-v-06a7ce78="" class="tag-item grey">招标</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">计综合甲级资质、建筑<span
														class="highlight-text-orange-bd">智能化</span>系统设计专项甲级资质，并在人员、设备、资金等方面具备相应的设计能力。
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">中城生态农业科技（宁夏）有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">开标日期</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">2024-12-21</span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-12-01</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">盂县第一中学校初中部教室<span
																class="highlight-text-orange-bd">智能化</span>巡课系统设备项目的更正公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">阳泉市</span><span
															data-v-06a7ce78="" class="tag-item grey">学校</span><span
															data-v-06a7ce78="" class="tag-item grey">变更</span><span
															data-v-06a7ce78="" class="tag-item grey">46.9万元</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">第一中学校初中部教室<span
														class="highlight-text-orange-bd">智能化</span>巡课系统设备项目的更正公告
													一、项目基本情况原公告的采购项目编号：1403222024ACS00094原公告的采购项目名称：盂县第一中学校初中部教室<span
														class="highlight-text-orange-bd">智能化</span>巡课系统设备项目首次公告日期：2024年11月20
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">盂县第一中学校</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">预算金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">46.9万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-12-01</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">北京大学第三医院秦皇岛医院配套基础设施项目信息化建设监理招标公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">秦皇岛市</span><span data-v-06a7ce78=""
															class="tag-item grey">卫健委</span><span data-v-06a7ce78=""
															class="tag-item grey">招标</span><span data-v-06a7ce78=""
															class="tag-item grey">191.87万元</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">应用软件、通用软件、<span
														class="highlight-text-orange-bd">智能化</span>应用软件搭建高水准医疗信息服务</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">秦皇岛市卫生健康委员会</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">预算金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">191.87万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">开标日期</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">2024-12-24</span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-12-01</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">厦门市湖里区2024P08地块及配套工程（施工“评定分离”）</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">厦门市</span><span data-v-06a7ce78=""
															class="tag-item grey">建筑业</span><span data-v-06a7ce78=""
															class="tag-item grey">招标</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">房）；永久供电工程；<span
														class="highlight-text-orange-bd">智能化</span>工程；电梯工程；公共配套用房工程；空中连廊工程
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">厦门兆元盛房地产开发有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">开标日期</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">2024-12-23</span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-12-01</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">中国电信股份有限公司无锡分公司宜兴市中学综合楼<span
																class="highlight-text-orange-bd">智能化</span>项目询比结果公示</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">无锡市</span><span
															data-v-06a7ce78="" class="tag-item grey">电信行业</span><span
															data-v-06a7ce78="" class="tag-item grey">成交</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">公司宜兴市中学综合楼<span
														class="highlight-text-orange-bd">智能化</span>项目询比结果公示
													中国电信股份有限公司无锡分公司宜兴市中学综合楼<span
														class="highlight-text-orange-bd">智能化</span>项目询比结果公示按照中国电信股份有限公司无锡分公司宜兴市中学综合楼<span
														class="highlight-text-orange-bd">智能化</span>项目（项目编号：ZYT-20241118
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">中国电信股份有限公司无锡分公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-12-01</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">中海油项目部-弱电<span
																class="highlight-text-orange-bd">智能化</span>专业分包工程-公开招标项目公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">海口市</span><span data-v-06a7ce78=""
															class="tag-item grey">能源化工</span><span data-v-06a7ce78=""
															class="tag-item grey">招标</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">中海油项目部-弱电<span
														class="highlight-text-orange-bd">智能化</span>专业分包工程-公开招标项目公告
													中化学建设（海南）有限公司中国海油深海能源开发总指挥部基地项目01地块标段施工总承包工程弱电<span
														class="highlight-text-orange-bd">智能化</span>专业分包工程采购招标公告1.招标条件中化学建设（海南）有限公司中国海油深海能源开发总指挥部基地项目
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">中化学建设（海南）有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-12-01</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">中电鸿信信息科技有限公司两高某小区系统集成项目（ICT）询比公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">泰州市</span><span
															data-v-06a7ce78="" class="tag-item grey">信息技术</span><span
															data-v-06a7ce78="" class="tag-item grey">询价</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">少1个类似项目业绩（<span
														class="highlight-text-orange-bd">智能化</span>或系统集成类似项目业绩）。</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">中电鸿信信息科技有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-12-01</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">霍尔果斯经济开发区伊宁园区<span
																class="highlight-text-orange-bd">智能化</span>管理创业标准化厂房二期建设项目配套附属工程（EPC）[招标计划]</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78=""
															class="tag-item grey">伊犁哈萨克自治州</span><span
															data-v-06a7ce78="" class="tag-item grey">金融业</span><span
															data-v-06a7ce78="" class="tag-item grey">采购意向</span><span
															data-v-06a7ce78="" class="tag-item grey">1500万元</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">斯经济开发区伊宁园区<span
														class="highlight-text-orange-bd">智能化</span>管理创业标准化厂房二期建设项目配套附属工程（EPC）[招标计划]
													自治区房屋建筑和市政基础设施工程建设项目招标计划表序号项目名称招标人（或项目法人）项目概况投资额（万元）资金来源招标方式计划招标时间1
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">霍尔果斯和祥建设投资有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">预算金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">1500万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-12-01</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">沈阳药科大学国家药物创新综合性平台检验检测中心扩大技术装备更新改造项目（十四）招标公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">沈阳市</span><span data-v-06a7ce78=""
															class="tag-item grey">学校</span><span data-v-06a7ce78=""
															class="tag-item grey">招标</span><span data-v-06a7ce78=""
															class="tag-item grey">275万元</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">三、软件部分<span
														class="highlight-text-orange-bd">智能化</span>软件，控制一切外围部件并至少具备如下功能：1、软件图像采集为流程化操作界面，简单易用，支持中英文切换，附赠中英文操作手册。
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">沈阳药科大学</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">预算金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">275万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">开标日期</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">2024-12-22</span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-12-01</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">济南护理职业学院电子班牌指纹门禁（教学<span
																class="highlight-text-orange-bd">智能化</span>设备）采购项目--电子班牌指纹门禁</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">济南市</span><span
															data-v-06a7ce78="" class="tag-item grey">学校</span><span
															data-v-06a7ce78="" class="tag-item grey">成交</span><span
															data-v-06a7ce78="" class="tag-item grey">2.98万元</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">子班牌指纹门禁（教学<span
														class="highlight-text-orange-bd">智能化</span>设备）采购项目--电子班牌指纹门禁
													济南护理职业学院电子班牌指纹门禁（教学<span
														class="highlight-text-orange-bd">智能化</span>设备）采购项目--电子班牌指纹门禁公共资源交易编号2024CGHW01X5008项目名称济南护理职业学院电子班牌指纹门禁
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">济南护理职业学院</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">中标金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">2.98万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-12-01</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">中电鸿信信息科技有限公司（泰州）两高某客户监控<span
																class="highlight-text-orange-bd">智能化</span>项目询比公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">泰州市</span><span
															data-v-06a7ce78="" class="tag-item grey">信息技术</span><span
															data-v-06a7ce78="" class="tag-item grey">询价</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">泰州）两高某客户监控<span
														class="highlight-text-orange-bd">智能化</span>项目询比公告
													中电鸿信信息科技有限公司（泰州）两高某客户监控<span
														class="highlight-text-orange-bd">智能化</span>项目询比公告本询比项目为【中电鸿信信息科技有限公司（泰州）两高某客户监控<span
														class="highlight-text-orange-bd">智能化</span>项目】（项目编号：【JSZB-2024
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">中电鸿信信息科技有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-12-01</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">金义新区健康生物医药产业园配套基础设施建设项目-配套员工宿舍（保障性租赁用房）项目设计（重新招标）</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">金华市</span><span
															data-v-06a7ce78="" class="tag-item grey">政府办</span><span
															data-v-06a7ce78="" class="tag-item grey">招标</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">的上建建筑结构设计、<span
														class="highlight-text-orange-bd">智能化</span>设计</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">金华市金东区塘雅镇人民政府</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-12-01</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">【福建】2024年福建公司呼叫中心基础平台升级研发工程单一来源采购公示</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">福州市</span><span data-v-06a7ce78=""
															class="tag-item grey">电信行业</span><span data-v-06a7ce78=""
															class="tag-item grey">单一</span><span data-v-06a7ce78=""
															class="tag-item grey">427.51万元</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">研呼叫中心基础平台的<span
														class="highlight-text-orange-bd">智能化</span>能力及视频客服应用能力提升，进一步推进平台的差异化AI能力融合化、提升客服的服务能力水平。
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">中国电信股份有限公司福建分公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">预算金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">427.51万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-12-01</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">潜江市路灯管理局潜江市城市照明<span
																class="highlight-text-orange-bd">智能化</span>节能改造项目招标公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">潜江市</span><span data-v-06a7ce78=""
															class="tag-item grey">市政</span><span data-v-06a7ce78=""
															class="tag-item grey">招标</span><span data-v-06a7ce78=""
															class="tag-item grey">1449.98万元</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">管理局潜江市城市照明<span
														class="highlight-text-orange-bd">智能化</span>节能改造项目招标公告
													【项目概况】潜江市城市照明<span
														class="highlight-text-orange-bd">智能化</span>节能改造项目招标项目的潜在投标人应在湖北省政府采购电子交易数据汇聚平台（网址：https://czt.hubei.gov.cn/zchj/user
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">潜江市路灯管理局</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">预算金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">1449.98万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">开标日期</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">2024-12-23</span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-12-01</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">河北医科大学第二医院儿科医疗中心室外工程招标计划</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">石家庄市</span><span data-v-06a7ce78=""
															class="tag-item grey">医疗</span><span data-v-06a7ce78=""
															class="tag-item grey">采购意向</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">管网、电缆及其管沟、<span
														class="highlight-text-orange-bd">智能化</span>及综合布线管线等内容项目负责人杜汉文联系电话0311-6600221
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">河北医科大学第二医院</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-12-01</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">2024年11月湖南人文科技学院弱电专业分包工程任务</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">娄底市</span><span data-v-06a7ce78=""
															class="tag-item grey">招标</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">程总承包工程项目弱电<span
														class="highlight-text-orange-bd">智能化</span>（采购内容）以邀请招标方式进行招标，合理低价择优选择供应商
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">湖南省第三工程有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">开标日期</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">2024-12-20</span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-12-01</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">[谈判采购]红岭公司智能工资结算系统项目采购公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">安阳市</span><span data-v-06a7ce78=""
															class="tag-item grey">能源化工</span><span data-v-06a7ce78=""
															class="tag-item grey">招标</span><span data-v-06a7ce78=""
															class="tag-item grey">18万元</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">内容:一、红岭煤矿的<span
														class="highlight-text-orange-bd">智能化</span>工资结算管理系统，全面覆盖了工资管理的各个环节，其功能包括:1、职工个人工资档案的电子化管理；2、每日工作积分的便捷录入；3、职工奖惩信息的精细管理
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">安阳鑫龙煤业（集团）红岭煤业有限责任公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">预算金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">18万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-12-01</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">梅溪湖国际新城区域能源站项目自控系统施工采购公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">长沙市</span><span data-v-06a7ce78=""
															class="tag-item grey">能源化工</span><span data-v-06a7ce78=""
															class="tag-item grey">招标</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">、投标人须提供电子与<span
														class="highlight-text-orange-bd">智能化</span>工程专业承包贰级及以上资质。拟派项目负责人须提供机电工程相关专业二级注册建造师及以上资格证书。3、投标人须提供2个及以上类似项目案例（类似项目指暖通集控系统、能源站、热力站等自控项目整体实施业绩）。
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">湖南新茂智慧能源有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-12-01</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">【内蒙古双欣矿业公司24105<span
																class="highlight-text-orange-bd">智能化</span>采煤工作面创新设计服务谈判采购项目】变更公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">鄂尔多斯市</span><span
															data-v-06a7ce78="" class="tag-item grey">采矿业</span><span
															data-v-06a7ce78="" class="tag-item grey">变更</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">欣矿业公司24105<span
														class="highlight-text-orange-bd">智能化</span>采煤工作面创新设计服务谈判采购项目】变更公告
													内蒙古双欣矿业公司24105<span
														class="highlight-text-orange-bd">智能化</span>采煤工作面创新设计服务谈判采购项目项目变更公告项目名称：内蒙古双欣矿业公司24105<span
														class="highlight-text-orange-bd">智能化</span>采煤工作面创新设计服务谈判采购项目项目编号
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">内蒙古双欣矿业有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-12-01</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">西一线局域网优化滁州站通信机房升级改造项目-非招标公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">滁州市</span><span data-v-06a7ce78=""
															class="tag-item grey">招标</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">级或以上资质或电子与<span
														class="highlight-text-orange-bd">智能化</span>工程专业承包二级或机电工程施工总承包三级及以上资质。
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">采购单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text highlight-text"><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="buyer-item link-clickable"></span></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-12-01</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">新能源项目<span
																class="highlight-text-orange-bd">智能化</span>设备材料询价采购公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">北京市</span><span data-v-06a7ce78=""
															class="tag-item grey">询价</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">新能源项目<span
														class="highlight-text-orange-bd">智能化</span>设备材料询价采购公告
													询价采购公告中国铁建大桥工程局集团有限公司长春汽开区新能源汽车产业园工程项目部采购编号：QKXNY-ZNHSB-045长春汽开区新能源汽车产业园工程项目，由于长春汽开区新能源汽车产业园工程项目由于
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">长春汽开区新能源汽车产业园工程项目部</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-12-01</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">桃源县高新区科创大厦办公楼<span
																class="highlight-text-orange-bd">智能化</span>工程</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">常德市</span><span
															data-v-06a7ce78="" class="tag-item grey">金融业</span><span
															data-v-06a7ce78="" class="tag-item grey">招标</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">高新区科创大厦办公楼<span
														class="highlight-text-orange-bd">智能化</span>工程 桃源县高新区科创大厦办公楼<span
														class="highlight-text-orange-bd">智能化</span>工程中标结果公示招标编号：CDWH2020-G-0016项目名称：桃源县高新区科创大厦办公楼<span
														class="highlight-text-orange-bd">智能化</span>工程招标代理：常德市伟恒招标咨询有限公司常德市伟恒招标咨询有限公司受桃源县经济开发区开发投资有限公司的委托
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">桃源县经济开发区开发投资有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-12-01</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">常德金鹏印务有限公司<span
																class="highlight-text-orange-bd">智能化</span>图形校对系统</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">常德市</span><span
															data-v-06a7ce78="" class="tag-item grey">招标</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">常德金鹏印务有限公司<span
														class="highlight-text-orange-bd">智能化</span>图形校对系统
													常德金鹏印务有限公司<span
														class="highlight-text-orange-bd">智能化</span>图形校对系统中标结果公告建银工程咨询有限责任公司受常德金鹏印务有限公司的委托，对其常德金鹏印务有限公司<span
														class="highlight-text-orange-bd">智能化</span>图形校对系统项目（招标编号：124307005809200481001698001001
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">常德金鹏印务有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-12-01</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">【内蒙古双欣矿业公司24105<span
																class="highlight-text-orange-bd">智能化</span>采煤工作面创新设计服务谈判采购项目】变更公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">山东</span><span data-v-06a7ce78=""
															class="tag-item grey">采矿业</span><span data-v-06a7ce78=""
															class="tag-item grey">变更</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">欣矿业公司24105<span
														class="highlight-text-orange-bd">智能化</span>采煤工作面创新设计服务谈判采购项目】变更公告
													【内蒙古双欣矿业公司24105<span
														class="highlight-text-orange-bd">智能化</span>采煤工作面创新设计服务谈判采购项目】变更公告详情请访问原网页！
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">内蒙古双欣矿业公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-12-01</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">【内蒙古双欣矿业公司24105<span
																class="highlight-text-orange-bd">智能化</span>采煤工作面创新设计服务谈判采购项目】谈判采购公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">鄂尔多斯市</span><span data-v-06a7ce78=""
															class="tag-item grey">采矿业</span><span data-v-06a7ce78=""
															class="tag-item grey">竞谈</span><span data-v-06a7ce78=""
															class="tag-item grey">49万元</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">归纳提炼<span
														class="highlight-text-orange-bd">智能化</span>采煤工作面建设成效，挖掘<span
														class="highlight-text-orange-bd">智能化</span>采煤工作面创新应用成果，总结不少于15项24105工作面<span
														class="highlight-text-orange-bd">智能化</span>创新建设项目。（详见技术规格书）1.3.1工期：施工之日起60天。1.3.2最高限价（含税）：490000元。
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">内蒙古双欣矿业有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">预算金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">49万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">开标日期</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">2024-12-04</span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-12-01</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">国投健康健康与居间健康设备采购项目询比采购公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">北京市</span><span data-v-06a7ce78=""
															class="tag-item grey">金融业</span><span data-v-06a7ce78=""
															class="tag-item grey">询价</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">及通讯设备安装服务、<span
														class="highlight-text-orange-bd">智能化</span>软件调试等相关项目经验，至少提供近三年有二项20万元以上的电子设备或<span
														class="highlight-text-orange-bd">智能化</span>应用设备相关销售业绩，优先考虑供给过养老机构、大型企业、事业单位的供应商等。
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">国投健康产业投资有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">开标日期</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">2024-12-05</span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-12-01</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">山东盛发干熄焦<span
																class="highlight-text-orange-bd">智能化</span>升级及降碳技改机电安装项目吊车租赁计划任务</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">山东</span><span data-v-06a7ce78=""
															class="tag-item grey">制造业</span><span data-v-06a7ce78=""
															class="tag-item grey">招标</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">山东盛发干熄焦<span
														class="highlight-text-orange-bd">智能化</span>升级及降碳技改机电安装项目吊车租赁计划任务
													报名截止时间：联系人：刘晶雨联系电话：18874974577联系邮箱：湖南省工业设备安装有限公司吊车租赁招标邀请函我公司湖南省工业设备安装有限公司山东盛发干熄焦<span
														class="highlight-text-orange-bd">智能化</span>升级及降碳技改机电安装工程需租赁吊车一批
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">湖南省工业设备安装有限公司&nbsp;&nbsp;&nbsp;
																二&nbsp; &nbsp;分公司</span></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-12-01</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">【内蒙古双欣矿业公司24105<span
																class="highlight-text-orange-bd">智能化</span>采煤工作面创新设计服务谈判采购项目】谈判采购公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">山东</span><span
															data-v-06a7ce78="" class="tag-item grey">采矿业</span><span
															data-v-06a7ce78="" class="tag-item grey">招标</span><span
															data-v-06a7ce78="" class="tag-item grey">49万元</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">欣矿业公司24105<span
														class="highlight-text-orange-bd">智能化</span>采煤工作面创新设计服务谈判采购项目】谈判采购公告
													项目概况招标方式公开谈判资格审查资格后审所属行业服务项目区域内蒙古自治区招标人内蒙古双欣矿业有限公司联系人杨元龙联系电话15947078907联系地址代理机构山东能源招标有限公司联系人时经理联系电话
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">内蒙古双欣矿业有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">预算金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">49万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">开标日期</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">2024-12-04</span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-12-01</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">中铁三局延榆9标衬砌<span
																class="highlight-text-orange-bd">智能化</span>系统公开竞争性谈判成交候选人公示</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">太原市</span><span
															data-v-06a7ce78="" class="tag-item grey">建筑业</span><span
															data-v-06a7ce78="" class="tag-item grey">中标</span><span
															data-v-06a7ce78="" class="tag-item grey">455.56万元</span>
													</div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">中铁三局延榆9标衬砌<span
														class="highlight-text-orange-bd">智能化</span>系统公开竞争性谈判成交候选人公示
													中铁三局延榆9标衬砌<span
														class="highlight-text-orange-bd">智能化</span>系统公开竞争性谈判ZTSJYY9B-ZBCG-2024-007采购类型:竞争性谈判采购单位:中铁三局集团有限公司延榆铁路YYZQ-9标段项目经理部组织单位
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">中铁三局集团有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">中标金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">455.56万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-12-01</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">【山东】中国电信山东分公司2024年多云管理平台升级研发工程项目直接采购公示</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">济南市</span><span
															data-v-06a7ce78="" class="tag-item grey">电信行业</span><span
															data-v-06a7ce78="" class="tag-item grey">招标</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">运营能力；实现资源池<span
														class="highlight-text-orange-bd">智能化</span>运维；实现资源池<span
														class="highlight-text-orange-bd">智能化</span>分析；增强自动化运维能力；业务网络规划，业务网络自动开通；满足集团考核要求。
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">中国电信股份有限公司山东分公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-12-01</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">枕水人家三期项目枕水人家三期项目<span
																class="highlight-text-orange-bd">智能化</span>设备采购及安装中标结果公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">淮安市</span><span data-v-06a7ce78=""
															class="tag-item grey">金融业</span><span data-v-06a7ce78=""
															class="tag-item grey">成交</span><span data-v-06a7ce78=""
															class="tag-item grey">407.14万元</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">项目枕水人家三期项目<span
														class="highlight-text-orange-bd">智能化</span>设备采购及安装中标结果公告
													枕水人家三期项目的中标公告项目编号E3208000337006139项目名称枕水人家三期项目标段编号E3208000337006139001001标段名称枕水人家三期项目<span
														class="highlight-text-orange-bd">智能化</span>设备采购及安装建设单位名称淮安市盱眙城市资产经营有限责任公司项目类型材料设备采购发包类型公开招标中标单位名称江苏移动信息系统集成有限公司
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">淮安市盱眙城市资产经营有限责任公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">中标金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">407.14万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-12-01</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">天津市中心妇产科医院天津市中心妇产科医院和平院区<span
																class="highlight-text-orange-bd">智能化</span>安全检查设备采购项目_第1包(项目编号:PYGP-2023-A-0153)合同公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">天津市</span><span
															data-v-06a7ce78="" class="tag-item grey">医疗</span><span
															data-v-06a7ce78="" class="tag-item grey">合同</span><span
															data-v-06a7ce78="" class="tag-item grey">67万元</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">心妇产科医院和平院区<span
														class="highlight-text-orange-bd">智能化</span>安全检查设备采购项目_第1包(项目编号:PYGP-2023-A-0153)合同公告
													天津市中心妇产科医院天津市中心妇产科医院和平院区<span
														class="highlight-text-orange-bd">智能化</span>安全检查设备采购项目_第1包(项目编号:
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">天津市中心妇产科医院</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">中标金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">67万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-12-01</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">(网)南宁未来方舟项目一期<span
																class="highlight-text-orange-bd">智能化</span>工程</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">南宁市</span><span data-v-06a7ce78=""
															class="tag-item grey">建筑业</span><span data-v-06a7ce78=""
															class="tag-item grey">招标</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">布信号覆盖系统，岗亭<span
														class="highlight-text-orange-bd">智能化</span>系统，红外对射报警系统、电子围栏报警系统，架空层配套空间、小区配套用房<span
														class="highlight-text-orange-bd">智能化</span>系统，智能家居系统</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">深圳市润置城市建设管理有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-12-01</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">成都局集团公司重庆铁路物流中心（重庆片区）2025年铁路货物装卸业务外包项目公开招标采购公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">重庆市</span><span data-v-06a7ce78=""
															class="tag-item grey">交通</span><span data-v-06a7ce78=""
															class="tag-item grey">招标</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">（其中至少6人须提供<span
														class="highlight-text-orange-bd">智能化</span>门吊培训合格证明），起重指挥Q1证（地面辅助人员）20人；管理人员至少3人，其中取得特种设备安全管理A证人员不少于2人。
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">中国铁路成都局集团有限公司重庆铁路物流中心</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">江西公司丰城公司锅炉<span
																class="highlight-text-orange-bd">智能化</span>加药系统开发与应用询价采购</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">宜春市</span><span data-v-06a7ce78=""
															class="tag-item grey">能源化工</span><span data-v-06a7ce78=""
															class="tag-item grey">询价</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">加药全流程的自动化、<span
														class="highlight-text-orange-bd">智能化</span>，减少人工干预、调整，满足机组水汽品质控制要求。
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">国能丰城发电有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">开标日期</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">2024-12-03</span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">2024年煤焦化公司南区脱硫脱硝协作项目、2024年煤焦化公司集装箱运输<span
																class="highlight-text-orange-bd">智能化</span>协作项目-变频电机冷却风扇等5项。</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">全国</span><span data-v-06a7ce78=""
															class="tag-item grey">其它</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">煤焦化公司集装箱运输<span
														class="highlight-text-orange-bd">智能化</span>协作项目-变频电机冷却风扇等5项。
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">采购单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text highlight-text"><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="buyer-item link-clickable"></span></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">珠江商管2024-2027年度零星工程改造框架服务项目（澄清）</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">广州市</span><span
															data-v-06a7ce78="" class="tag-item grey">竞谈</span><span
															data-v-06a7ce78="" class="tag-item grey">3000万元</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">或以上资质：①电子与<span
														class="highlight-text-orange-bd">智能化</span>工程专业承包三级或以上资质</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">广州珠江商业经营管理有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">预算金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">3000万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">开标日期</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">2024-12-12</span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">绵竹高新技术产业园区管理委员会新市化工园区<span
																class="highlight-text-orange-bd">智能化</span>管控平台可燃有毒气体速扫功能提升采购项目公开招标更正公告（第三次）</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">德阳市</span><span
															data-v-06a7ce78="" class="tag-item grey">政府办</span><span
															data-v-06a7ce78="" class="tag-item grey">变更</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">理委员会新市化工园区<span
														class="highlight-text-orange-bd">智能化</span>管控平台可燃有毒气体速扫功能提升采购项目公开招标更正公告（第三次）
													一、项目基本情况原公告的采购项目编号：N5106832024000160原公告的采购项目名称：新市化工园区<span
														class="highlight-text-orange-bd">智能化</span>管控平台可燃有毒气体速扫功能提升采购项目首次公告日期
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">绵竹高新技术产业园区管理委员会</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">开标日期</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">2024-12-02</span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">海珍新城二期附属配套（<span
																class="highlight-text-orange-bd">智能化</span>）工程定标</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">防城港市</span><span data-v-06a7ce78=""
															class="tag-item grey">运输物流</span><span data-v-06a7ce78=""
															class="tag-item grey">成交</span><span data-v-06a7ce78=""
															class="tag-item grey">216.88万元</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">珍新城二期附属配套（<span
														class="highlight-text-orange-bd">智能化</span>）工程定标
													项目名称：海珍新城二期附属配套（<span
														class="highlight-text-orange-bd">智能化</span>）工程采购方：防城港务集团有限公司成交金额：人民币2168847.12元采购内容：海珍新城二期<span
														class="highlight-text-orange-bd">智能化</span>工程供应商资格条件：具备承接过类似规模房地产楼盘的<span
														class="highlight-text-orange-bd">智能化</span>系统工程的经验</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">防城港务集团有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">中标金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">216.88万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">玉门市东镇污水处理厂设备<span
																class="highlight-text-orange-bd">智能化</span>升级改造项目</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">酒泉市</span><span data-v-06a7ce78=""
															class="tag-item grey">拟建</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">市东镇污水处理厂设备<span
														class="highlight-text-orange-bd">智能化</span>升级改造项目
													项目基本信息项目代码2411-620981-04-02-250174项目名称玉门市东镇污水处理厂设备<span
														class="highlight-text-orange-bd">智能化</span>升级改造项目审批事项公示信息审批部门审批事项办理结果办理时间审批文号酒泉市玉门市发展和改革局企业投资项目备案不准予许可
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">采购单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text highlight-text"><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="buyer-item link-clickable"></span></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">永州市看守所关于监控系统工程安装的网上超市采购项目成交公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">永州市</span><span data-v-06a7ce78=""
															class="tag-item grey">公安</span><span data-v-06a7ce78=""
															class="tag-item grey">成交</span><span data-v-06a7ce78=""
															class="tag-item grey">2.01万元</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">金额（元）报价明细1<span
														class="highlight-text-orange-bd">智能化</span>日常维护</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">永州市看守所</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">中标金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">2.01万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">材科院实验研究全面<span
																class="highlight-text-orange-bd">智能化</span>管理系统实施项目</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">北京市</span><span
															data-v-06a7ce78="" class="tag-item grey">成交</span><span
															data-v-06a7ce78="" class="tag-item grey">396.86万元</span>
													</div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">材科院实验研究全面<span
														class="highlight-text-orange-bd">智能化</span>管理系统实施项目
													项目概况项目名称:材科院实验研究全面<span
														class="highlight-text-orange-bd">智能化</span>管理系统实施项目标段编号:YJSCQF14476YJ/01标段名称:材科院实验研究全面<span
														class="highlight-text-orange-bd">智能化</span>管理系统实施项目公告开始时间:2024-11-3010:
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">采购单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text highlight-text"><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="buyer-item link-clickable"></span></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">中标金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">396.86万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">云南烟草商业科技研发中心建设项目<span
																class="highlight-text-orange-bd">智能化</span>专项工程-结果公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">昆明市</span><span data-v-06a7ce78=""
															class="tag-item grey">制造业</span><span data-v-06a7ce78=""
															class="tag-item grey">成交</span><span data-v-06a7ce78=""
															class="tag-item grey">2594.08万元</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">科技研发中心建设项目<span
														class="highlight-text-orange-bd">智能化</span>专项工程-结果公告
													公告云南烟草商业科技研发中心建设项目<span
														class="highlight-text-orange-bd">智能化</span>专项工程-结果公告(招标编号：TC2405G5Q)本云南烟草商业科技研发中心建设项目<span
														class="highlight-text-orange-bd">智能化</span>专项工程（招标项目编号：TC2405G5Q
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">中国烟草总公司云南省公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">中标金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">2594.08万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">中铁二局雄安建设发展有限公司启动区XACR-2023-007地块项目施工总承包标段三项目防水工程招标招标公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">保定市</span><span
															data-v-06a7ce78="" class="tag-item grey">建筑业</span><span
															data-v-06a7ce78="" class="tag-item grey">招标</span><span
															data-v-06a7ce78="" class="tag-item grey">299.03万元</span>
													</div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">市政工程、泛光照明、<span
														class="highlight-text-orange-bd">智能化</span>工程</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">中铁二局雄安建设发展有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">预算金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">299.03万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">济南未来产业算网用一体化项目-山东未来云谷节点智算中心机房设计-济南未来产业算网用一体化项目-山东未来云谷节点智算中心机房设计</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">济南市</span><span data-v-06a7ce78=""
															class="tag-item grey">招标</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">防、电源、暖通空调、<span
														class="highlight-text-orange-bd">智能化</span>、机柜工艺等系统的设计，可满足不少于46台机柜的使用，单机柜功率8-50kW不等，制冷形式采用风冷及液冷方案。
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">济南市中未来产业发展有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">开标日期</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">2024-12-26</span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">阿克陶县雪松中学关于计算机网络系统工程的服务市场采购项目成交公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">克孜勒苏柯尔克孜自治州</span><span
															data-v-06a7ce78="" class="tag-item grey">学校</span><span
															data-v-06a7ce78="" class="tag-item grey">成交</span><span
															data-v-06a7ce78="" class="tag-item grey">4600元</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">各单位水电暖网路维修<span
														class="highlight-text-orange-bd">智能化</span>安装工程计算机网络系统工程</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">阿克陶县雪松中学</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">中标金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">4600元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">阿克陶县雪松中学关于计算机网络系统工程的服务市场采购项目成交公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">克孜勒苏柯尔克孜自治州</span><span
															data-v-06a7ce78="" class="tag-item grey">学校</span><span
															data-v-06a7ce78="" class="tag-item grey">成交</span><span
															data-v-06a7ce78="" class="tag-item grey">1.85万元</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">智能设备，网络维修，<span
														class="highlight-text-orange-bd">智能化</span>安装工程</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">阿克陶县雪松中学</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">中标金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">1.85万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">绍兴路智能家居设备<span
																class="highlight-text-orange-bd">智能化</span>项目竞争性磋商公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">青岛市</span><span
															data-v-06a7ce78="" class="tag-item grey">交通</span><span
															data-v-06a7ce78="" class="tag-item grey">竞谈</span><span
															data-v-06a7ce78="" class="tag-item grey">170.11万元</span>
													</div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">绍兴路智能家居设备<span
														class="highlight-text-orange-bd">智能化</span>项目竞争性磋商公告
													绍兴路智能家居设备<span
														class="highlight-text-orange-bd">智能化</span>项目竞争性磋商公告(招标编号:QDDJ-2024031)项目所在地区:山东省,青岛市一、招标条件本绍兴路智能家居设备<span
														class="highlight-text-orange-bd">智能化</span>项目已由项目审批/核准/备案机关批准,项目资金来源为其他资金
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">青岛城市轨道交通科技有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">预算金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">170.11万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">开标日期</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">2024-12-10</span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">山东港口科技集团有限公司新办公楼光纤到桌建设项目</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">青岛市</span><span data-v-06a7ce78=""
															class="tag-item grey">竞谈</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">项目定义：网络设备的<span
														class="highlight-text-orange-bd">智能化</span>相关建设业绩），每份业绩需同时提供合同及对应的发票扫描件（提供可用于核验真伪的发票显示信息，需在国家税务总局全国增值税发票查验平台上可查
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">山东港口科技集团有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">国网吉林四平供电公司调度通信综合楼<span
																class="highlight-text-orange-bd">智能化</span>分系统数据贯通改造</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">四平市</span><span data-v-06a7ce78=""
															class="tag-item grey">成交</span><span data-v-06a7ce78=""
															class="tag-item grey">36.61万元</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">电公司调度通信综合楼<span
														class="highlight-text-orange-bd">智能化</span>分系统数据贯通改造改造中标结果公示表项目名称国网吉林四平供电公司调度通信综合楼<span
														class="highlight-text-orange-bd">智能化</span>分系统数据贯通改造改造中标人名称深圳市电信工程有限公司投标报价366180元质量合格工期（交货期）31项目负责人姓名谢斌焕职称证书工程师注册执业资格一级建造师
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">采购单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text highlight-text"><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="buyer-item link-clickable"></span></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">中标金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">36.61万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">中石化江汉石油工程设计有限公司兴隆气田长兴组气藏开发项目地面工程集输系统安防监控系统\含视频监控系统,门禁系统,传输系统,综合布线系统等30-50点招标公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">武汉市</span><span data-v-06a7ce78=""
															class="tag-item grey">能源化工</span><span data-v-06a7ce78=""
															class="tag-item grey">招标</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">商以具备有效的电子与<span
														class="highlight-text-orange-bd">智能化</span>工程专业承包贰级及以上资质为界定依据。3.1.2财务要求。无3.1.3业绩要求。无3.1.4信誉要求。（1）投标人近两年内没有发生重大安全责任事故。
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">中石化江汉石油工程设计有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">开标日期</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">2024-12-24</span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">【设备类】中国电建电建生态公司中电建水环境科技有限公司济南市大明湖排水分区工程智慧排水工区管网水质监测设备采购项目招标公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">济南市</span><span
															data-v-06a7ce78="" class="tag-item grey">招标</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">2、具有电子与<span
														class="highlight-text-orange-bd">智能化</span>工程专业承包二级及以上资质。3、投标人自2021年1月1日至今至少具有1个水务或水利信息化系统集成项目业绩或相关项目供货业绩。
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">中电建水环境科技有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">开标日期</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">2024-12-18</span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">年产1200万KVAH新型动力电池绿色化、<span
																class="highlight-text-orange-bd">智能化</span>技改项目</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">湖州市</span><span
															data-v-06a7ce78="" class="tag-item grey">拟建</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">新型动力电池绿色化、<span
														class="highlight-text-orange-bd">智能化</span>技改项目
													项目基本信息项目代码2011-330522-07-02-161541项目名称年产1200万KVAH新型动力电池绿色化、<span
														class="highlight-text-orange-bd">智能化</span>技改项目审批事项公示信息审批部门审批事项办理结果办理时间审批文号附件长兴县应急管理局金属冶炼建设项目安全设施设计审查退办
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">采购单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text highlight-text"><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="buyer-item link-clickable"></span></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">温州湾新区温州东泰树脂有限责任公司水性肤感处理剂节能降耗<span
																class="highlight-text-orange-bd">智能化</span>技改项目</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">温州市</span><span
															data-v-06a7ce78="" class="tag-item grey">拟建</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">性肤感处理剂节能降耗<span
														class="highlight-text-orange-bd">智能化</span>技改项目
													项目基本信息项目代码2411-330303-07-02-353050项目名称温州湾新区温州东泰树脂有限责任公司水性肤感处理剂节能降耗<span
														class="highlight-text-orange-bd">智能化</span>技改项目审批事项公示信息审批部门审批事项办理结果办理时间审批文号附件龙湾区经济和信息化局企业投资
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">采购单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text highlight-text"><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="buyer-item link-clickable"></span></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">南宁市平阳村片区城中村改造项目(A-35地块)中标结果公示</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">南宁市</span><span
															data-v-06a7ce78="" class="tag-item grey">金融业</span><span
															data-v-06a7ce78="" class="tag-item grey">成交</span><span
															data-v-06a7ce78="" class="tag-item grey">9288.96万元</span>
													</div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">排水工程、电气工程、<span
														class="highlight-text-orange-bd">智能化</span>工程</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">南宁城新投资发展有限责任公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">中标金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">9288.96万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">开标日期</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">2024-11-25</span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">武钢物流计算机、视频监控终端设备及港区无人道口维护等服务</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">武汉市</span><span data-v-06a7ce78=""
															class="tag-item grey">其它</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">5.2电子与<span
														class="highlight-text-orange-bd">智能化</span>工程专业承包二级及以上或机电设备安装三级（或维修）及以上资质。5.3报价人具有安全生产许可证书。5.4报价人人在武汉本地设有固定的售后服务机构。
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">采购单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text highlight-text"><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="buyer-item link-clickable"></span></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">中色大冶供应链管理中心物流公司智能道闸系统采购项目竞价公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">北京市</span><span
															data-v-06a7ce78="" class="tag-item grey">能源化工</span><span
															data-v-06a7ce78="" class="tag-item grey">竞价</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">计量单位*备注1门禁<span
														class="highlight-text-orange-bd">智能化</span>道闸系统杆长</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">中色大冶大冶有色金属有限责任公司供应链管理中心</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">开标日期</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">2024-12-05</span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">财信证券投行智能审核平台应用系统采购项目采购公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">长沙市</span><span data-v-06a7ce78=""
															class="tag-item grey">金融业</span><span data-v-06a7ce78=""
															class="tag-item grey">竞谈</span><span data-v-06a7ce78=""
															class="tag-item grey">40万元</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">误，实现规范性审核，<span
														class="highlight-text-orange-bd">智能化</span>避错；支持招股说明书</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">财信证券股份有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">预算金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">40万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">中国铁塔股份有限公司南通市分公司RDJCSG智慧集成服务项目比选公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">南通市</span><span
															data-v-06a7ce78="" class="tag-item grey">电信行业</span><span
															data-v-06a7ce78="" class="tag-item grey">招标</span><span
															data-v-06a7ce78="" class="tag-item grey">80.13万元</span>
													</div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">具备以下资质：电子与<span
														class="highlight-text-orange-bd">智能化</span>工程专业承包二级及以上资质或建筑机电工程专业承包乙级及以上资质。
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">中国铁塔股份有限公司南通市分公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">预算金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">80.13万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">开标日期</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">2024-12-09</span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">福田领益大厦一楼、13-16F<span
																class="highlight-text-orange-bd">智能化</span>安装项目</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">深圳市</span><span data-v-06a7ce78=""
															class="tag-item grey">拟建</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">厦一楼、13-16F<span
														class="highlight-text-orange-bd">智能化</span>安装项目
													国家编码项目名称项目单位立项类型立项时间2411-440304-04-05-799698福田领益大厦一楼、13-16F<span
														class="highlight-text-orange-bd">智能化</span>安装项目深圳市东方亮彩精密技术有限公司备案2024-11-30
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">采购单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text highlight-text"><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="buyer-item link-clickable"></span></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">【福建】2024年中国电信厦门分公司湖里区某大楼<span
																class="highlight-text-orange-bd">智能化</span>系统集成项目成交结果公示</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">厦门市</span><span
															data-v-06a7ce78="" class="tag-item grey">电信行业</span><span
															data-v-06a7ce78="" class="tag-item grey">成交</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">门分公司湖里区某大楼<span
														class="highlight-text-orange-bd">智能化</span>系统集成项目成交结果公示
													2024年中国电信厦门分公司湖里区某大楼<span
														class="highlight-text-orange-bd">智能化</span>系统集成项目成交结果公示按照2024年中国电信厦门分公司湖里区某大楼<span
														class="highlight-text-orange-bd">智能化</span>系统集成项目（项目编号：FJZT
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">中国电信厦门分公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">【福建】2024年中国电信厦门分公司某港<span
																class="highlight-text-orange-bd">智能化</span>项目成交结果公示</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">厦门市</span><span
															data-v-06a7ce78="" class="tag-item grey">电信行业</span><span
															data-v-06a7ce78="" class="tag-item grey">成交</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">国电信厦门分公司某港<span
														class="highlight-text-orange-bd">智能化</span>项目成交结果公示
													2024年中国电信厦门分公司某港<span
														class="highlight-text-orange-bd">智能化</span>项目成交结果公示按照2024年中国电信厦门分公司某港<span
														class="highlight-text-orange-bd">智能化</span>项目（项目编号：FJZT-2024-11913）【标段（包）名称：2024
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">中国电信厦门分公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">武汉市红十字会医院扩建（北区）项目-弱电信息化系统建设项目招标计划</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">武汉市</span><span data-v-06a7ce78=""
															class="tag-item grey">金融业</span><span data-v-06a7ce78=""
															class="tag-item grey">采购意向</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">建（北区）项目的弱电<span
														class="highlight-text-orange-bd">智能化</span>配套工程</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">武汉金融街集团有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">温州市双龙建设发展有限公司2024年11月至12月政府采购意向</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">温州市</span><span data-v-06a7ce78=""
															class="tag-item grey">建筑业</span><span data-v-06a7ce78=""
															class="tag-item grey">采购意向</span><span data-v-06a7ce78=""
															class="tag-item grey">98万元</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">量检定实验室装修工程<span
														class="highlight-text-orange-bd">智能化</span>采购<span
														class="highlight-text-orange-bd">智能化</span>采购</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">温州市双龙建设发展有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">预算金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">98万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">年产50万平方米新型三维铝锥芯航空板生产线<span
																class="highlight-text-orange-bd">智能化</span>改造项目</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">襄阳市</span><span data-v-06a7ce78=""
															class="tag-item grey">拟建</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">维铝锥芯航空板生产线<span
														class="highlight-text-orange-bd">智能化</span>改造项目
													项目名称年产50万平方米新型三维铝锥芯航空板生产线<span
														class="highlight-text-orange-bd">智能化</span>改造项目项目代码2411-420625-04-02-262565建设内容及规改造厂房4000平米；购置数字化钣金作业、
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">采购单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text highlight-text"><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="buyer-item link-clickable"></span></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">中铁建工大河片区安置房及配套设施工程标段四项目弱电<span
																class="highlight-text-orange-bd">智能化</span>工程招标公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">保定市</span><span
															data-v-06a7ce78="" class="tag-item grey">建筑业</span><span
															data-v-06a7ce78="" class="tag-item grey">招标</span><span
															data-v-06a7ce78="" class="tag-item grey">2223.08万元</span>
													</div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">施工程标段四项目弱电<span
														class="highlight-text-orange-bd">智能化</span>工程进行公开招标。</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">中铁建工集团有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">预算金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">2223.08万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">开标日期</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">2024-12-09</span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">2025年西昌钢钒有限公司大型检化验设备设施维修招标公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">攀枝花市</span><span
															data-v-06a7ce78="" class="tag-item grey">制造业</span><span
															data-v-06a7ce78="" class="tag-item grey">招标</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">（6）提供电子与<span
														class="highlight-text-orange-bd">智能化</span>工程专业承包二级资质，资质材料必须提供原件的扫描件或照片。其他要求：详见附件（如有需要）3.6本次招标要求依法必须进行招标的项目，失信被执行人投标无效。
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">攀钢集团攀枝花钢钒有限公司装备部</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">开标日期</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">2024-12-09</span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">广东公司台山电厂输煤系统采制样<span
																class="highlight-text-orange-bd">智能化</span>改造土建施工询价采购采购结果公告（采购编号NFSB-SGXJ-2024110331）</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">江门市</span><span data-v-06a7ce78=""
															class="tag-item grey">能源化工</span><span data-v-06a7ce78=""
															class="tag-item grey">成交</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">山电厂输煤系统采制样<span
														class="highlight-text-orange-bd">智能化</span>改造土建施工询价采购采购结果公告（采购编号NFSB-SGXJ-2024110331）
													广东公司台山电厂输煤系统采制样<span
														class="highlight-text-orange-bd">智能化</span>改造土建施工询价采购项目采购2024-11-3013:56:03发起异议/
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">国能粤电台山发电有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">智能校对软件服务结果公告</span><!----></div>
													<!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">昭通市</span><span data-v-06a7ce78=""
															class="tag-item grey">学校</span><span data-v-06a7ce78=""
															class="tag-item grey">成交</span><span data-v-06a7ce78=""
															class="tag-item grey">2万元</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">在发布前进行自动化、<span
														class="highlight-text-orange-bd">智能化</span>的错敏检测，快速识别政治敏感内容、常见错别字、不规范表述并给出高亮提示和纠错建议
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">昭通学院</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">预算金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">2.2万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">中标金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">2万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">开标日期</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">2024-11-28</span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">河北公司定州公司<span
																class="highlight-text-orange-bd">智能化</span>设备现场应用研究公开招标中标候选人公示</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">保定市</span><span data-v-06a7ce78=""
															class="tag-item grey">中标</span><span data-v-06a7ce78=""
															class="tag-item grey">353.73万元</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">河北公司定州公司<span
														class="highlight-text-orange-bd">智能化</span>设备现场应用研究公开招标中标候选人公示
													河北公司定州公司<span
														class="highlight-text-orange-bd">智能化</span>设备现场应用研究公开招标项目中标候选人公示项目名称：河北公司定州公司<span
														class="highlight-text-orange-bd">智能化</span>设备现场应用研究公开招标招标编号及包号：CEZB240010510001一
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">河北公司定州公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">中标金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">353.73万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">星海音乐学院装修工程定点竞价采购公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">广州市</span><span
															data-v-06a7ce78="" class="tag-item grey">学校</span><span
															data-v-06a7ce78="" class="tag-item grey">竞价</span><span
															data-v-06a7ce78="" class="tag-item grey">66万元</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">41、需具备电子与<span
														class="highlight-text-orange-bd">智能化</span>工程专业承包贰级相关资质（上传佐证材料）2、需具备安全生产许可证（上传佐证材料）（五）竞价公告时间：2024-11-3013:20:27~2024-12-0500:00:00（六）供应商报价时间：2024-12
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">星海音乐学院</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">预算金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">66万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">中国五冶武侯区双华数字健康产业园D区项目小区<span
																class="highlight-text-orange-bd">智能化</span>工程</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">成都市</span><span data-v-06a7ce78=""
															class="tag-item grey">制造业</span><span data-v-06a7ce78=""
															class="tag-item grey">招标</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">D区项目小区<span
														class="highlight-text-orange-bd">智能化</span>工程3、招标范围：包含武侯区双华数字健康产业园D区项目小区<span
														class="highlight-text-orange-bd">智能化</span>工程等相关所有内容（以招标人提供图纸及分部分项工程量清单描述为准）。
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">中国五冶集团有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">2024年中国联通广东湛江提质增效专项基站叠光改造项目比选公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">湛江市</span><span data-v-06a7ce78=""
															class="tag-item grey">电信行业</span><span data-v-06a7ce78=""
															class="tag-item grey">招标</span><span data-v-06a7ce78=""
															class="tag-item grey">24.32万元</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">，实现基站内数字化、<span
														class="highlight-text-orange-bd">智能化</span>管理，达到提质增效、节能减排等效果。1.3采购预算：243200元（不含税）。
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">中国联合网络通信有限公司湛江市分公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">预算金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">24.32万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">2024年中国联通广东湛江提质增效专项空调智能恒温控制节能项目比选公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">湛江市</span><span data-v-06a7ce78=""
															class="tag-item grey">电信行业</span><span data-v-06a7ce78=""
															class="tag-item grey">招标</span><span data-v-06a7ce78=""
															class="tag-item grey">32.5万元</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">，实现基站内数字化、<span
														class="highlight-text-orange-bd">智能化</span>管理，达到提质增效、节能减排等效果。1.3采购预算：325000元（不含税）。
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">中国联合网络通信有限公司湛江市分公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">预算金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">32.5万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">中铁五局集团路桥工程有限责任公司广州南沙2022NJY-8地块项目一期勘察设计施工总承包项目经理部铝合金门窗、幕墙工程1标，铝合金门窗工程2标，地块三水电工程招标公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">广州市</span><span
															data-v-06a7ce78="" class="tag-item grey">建筑业</span><span
															data-v-06a7ce78="" class="tag-item grey">招标</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">地下室<span
														class="highlight-text-orange-bd">智能化</span>（配管、套管、接线盒）一切相关的工作内容。12地块三地下室<span
														class="highlight-text-orange-bd">智能化</span>（线槽、支架）平方米83654.31所有施工内容均包工包料。
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">中铁五局集团路桥工程有限责任公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">鞍钢集团财务共享<span
																class="highlight-text-orange-bd">智能化</span>二期项目智慧客服软件产品授权服务分包</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">深圳市</span><span
															data-v-06a7ce78="" class="tag-item grey">公共资源交易</span><span
															data-v-06a7ce78="" class="tag-item grey">其它</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">鞍钢集团财务共享<span
														class="highlight-text-orange-bd">智能化</span>二期项目智慧客服软件产品授权服务分包
													中标候选人公示鞍钢集团自动化有限公司商务中心采购中心受鞍钢集团自动化有限公司商务中心采购中心委托，对鞍钢集团财务共享<span
														class="highlight-text-orange-bd">智能化</span>二期项目智慧客服软件产品授权服务分包（ZXSWZXFYTHD241113168238
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">鞍钢集团自动化有限公司商务中心采购中心</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">开标日期</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">2024-11-13</span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">中铁七局集团中信银行（合肥）金融后台服务中心项目<span
																class="highlight-text-orange-bd">智能化</span>工程（Ⅱ标段）项目<span
																class="highlight-text-orange-bd">智能化</span>材料采购招标中标候选人公示</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">合肥市</span><span
															data-v-06a7ce78="" class="tag-item grey">金融业</span><span
															data-v-06a7ce78="" class="tag-item grey">中标</span><span
															data-v-06a7ce78="" class="tag-item grey">673.13万元</span>
													</div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">金融后台服务中心项目<span
														class="highlight-text-orange-bd">智能化</span>工程（Ⅱ标段）项目<span
														class="highlight-text-orange-bd">智能化</span>材料采购招标中标候选人公示
													中铁七局集团电务工程有限公司中信银行（合肥）金融后台服务中心项目<span
														class="highlight-text-orange-bd">智能化</span>工程（Ⅱ标段）项目物资公开招标采购成交候选人公示各投标人
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">中铁七局集团中信银行</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">中标金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">673.13万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">鞍钢集团财务共享<span
																class="highlight-text-orange-bd">智能化</span>二期项目-85寸高清显示器招标公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">大连市</span><span
															data-v-06a7ce78="" class="tag-item grey">制造业</span><span
															data-v-06a7ce78="" class="tag-item grey">招标</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">鞍钢集团财务共享<span
														class="highlight-text-orange-bd">智能化</span>二期项目-85寸高清显示器招标公告
													鞍钢集团财务共享<span
														class="highlight-text-orange-bd">智能化</span>二期项目-85寸高清显示器招标招标公告招标招标条件本招标项目鞍钢集团财务共享<span
														class="highlight-text-orange-bd">智能化</span>二期项目-85寸高清显示器（AGXXCYHGZHD241018163371
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">鞍钢集团信息产业有限公司商务运营部</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">中铁七局集团有限公司中信银行（合肥）金融后台服务中心项目<span
																class="highlight-text-orange-bd">智能化</span>系统设备采购招标中标候选人公示</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">合肥市</span><span
															data-v-06a7ce78="" class="tag-item grey">建筑业</span><span
															data-v-06a7ce78="" class="tag-item grey">中标</span><span
															data-v-06a7ce78="" class="tag-item grey">1591.75万元</span>
													</div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">金融后台服务中心项目<span
														class="highlight-text-orange-bd">智能化</span>工程（Ⅱ标段）项目物资公开招标采购(招标编号：ZTQJ2024-119)，评标工作已经结束，现将评标委员会评审结果公示如下：1.中铁七局集团电务工程有限公司中信银行（合肥）金融后台服务中心项目<span
														class="highlight-text-orange-bd">智能化</span>工程</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">中铁七局集团有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">中标金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">1591.75万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">公开进出口数据的外贸统计分析系统技术服务项目采购公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">武汉市</span><span
															data-v-06a7ce78="" class="tag-item grey">招标</span><span
															data-v-06a7ce78="" class="tag-item grey">8.83万元</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">倡向着高效、数字化、<span
														class="highlight-text-orange-bd">智能化</span>转型，因此，对于这些企业机构而言，也是急需数据的智能管理系统，以提高企业的效率、充分利用数据资源挖掘市场机会，为决策做支撑。
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">湖北省楚天云有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">预算金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">8.83万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">开标日期</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">2024-12-06</span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">新东仓储园物流中心<span
																class="highlight-text-orange-bd">智能化</span>立库项目[重新招标第1次]</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">连云港市</span><span
															data-v-06a7ce78="" class="tag-item grey">成交</span><span
															data-v-06a7ce78="" class="tag-item grey">3861万元</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">新东仓储园物流中心<span
														class="highlight-text-orange-bd">智能化</span>立库项目[重新招标第1次]
													中标结果公示根据招标投标的有关法律、法规、规章和本项目招标文件的规定，连云港维创科技服务有限公司连云港维创科技服务有限公司的新东仓储园物流中心<span
														class="highlight-text-orange-bd">智能化</span>立库项目的评标工作已经结束，中标人确定
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">连云港维创科技服务有限公司连云港维创科技服务有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">中标金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">3861万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">资产<span
																class="highlight-text-orange-bd">智能化</span>建设项目（四次）中标公示</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">宣城市</span><span
															data-v-06a7ce78="" class="tag-item grey">成交</span><span
															data-v-06a7ce78="" class="tag-item grey">56.49万元</span>
													</div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">资产<span
														class="highlight-text-orange-bd">智能化</span>建设项目（四次）中标公示 资产<span
														class="highlight-text-orange-bd">智能化</span>建设项目（四次）成交结果公告一、项目编号：HXJY1110001030070二、项目名称：资产<span
														class="highlight-text-orange-bd">智能化</span>建设项目（四次）三、成交信息供应商名称：安徽铉泊网络工程有限公司供应商地址：安徽省宣城市宁国市南山街道白云路光彩大市场
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">宁国市阳诚城市服务有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">中标金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">56.49万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">河南南阳市中心医院迁建<span
																class="highlight-text-orange-bd">智能化</span>设备采购项目采购公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">南阳市</span><span
															data-v-06a7ce78="" class="tag-item grey">金融业</span><span
															data-v-06a7ce78="" class="tag-item grey">招标</span><span
															data-v-06a7ce78="" class="tag-item grey">1003.82万元</span>
													</div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">南南阳市中心医院迁建<span
														class="highlight-text-orange-bd">智能化</span>设备采购项目采购公告
													河南南阳市中心医院迁建<span
														class="highlight-text-orange-bd">智能化</span>设备采购项目询比采购公告本项目河南南阳市中心医院迁建<span
														class="highlight-text-orange-bd">智能化</span>设备采购项目已具备采购条件，现公开邀请供应商参加询比采购活动。
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">湖北工建科技产业投资有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">预算金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">1003.82万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">开标日期</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">2024-12-04</span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">襄阳市南漳县鄂汇办旗舰店项目采购公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">襄阳市</span><span
															data-v-06a7ce78="" class="tag-item grey">招标</span><span
															data-v-06a7ce78="" class="tag-item grey">55万元</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">意度，推动政务服务向<span
														class="highlight-text-orange-bd">智能化</span>、移动化方向发展，进一步优化营商环境，提升城市形象和竞争力。
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">湖北省楚天云有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">预算金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">55万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">开标日期</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">2024-12-06</span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">阿克陶县雪松中学关于计算机网络系统工程的服务市场采购项目成交公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">克孜勒苏柯尔克孜自治州</span><span
															data-v-06a7ce78="" class="tag-item grey">学校</span><span
															data-v-06a7ce78="" class="tag-item grey">成交</span><span
															data-v-06a7ce78="" class="tag-item grey">1.54万元</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">各单位水电暖网路维修<span
														class="highlight-text-orange-bd">智能化</span>安装工程计算机网络系统工程</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">阿克陶县雪松中学</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">中标金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">1.54万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">新河浦历史文化街区改造提升工程_新河浦历史文化街区改造提升项目—新河浦历史文化街区建筑活化及环境综合提升工程勘察、方案设计及初步设计</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">邢台市</span><span
															data-v-06a7ce78="" class="tag-item grey">招标</span><span
															data-v-06a7ce78="" class="tag-item grey">590.69万元</span>
													</div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">区域的老旧消火栓进行<span
														class="highlight-text-orange-bd">智能化</span>更换升级，优化区域内慢行交通系统，提升市政景观、环卫系统等进行更换升级。
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">采购单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text highlight-text"><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="buyer-item link-clickable"></span></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">预算金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">590.69万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">【河南鑫泰能源有限公司环保超低平台升级改造竞争性谈判项目(二次)】谈判公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">安阳市</span><span data-v-06a7ce78=""
															class="tag-item grey">能源化工</span><span data-v-06a7ce78=""
															class="tag-item grey">竞谈</span><span data-v-06a7ce78=""
															class="tag-item grey">40万元</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">公司现有环保超低排放<span
														class="highlight-text-orange-bd">智能化</span>监管系统是按照2021年重污染天气重点行业绩效分级B级企业要求进行建设,根据生态环境部《关于推进实施焦化行业超低排放的意见》、河南省生态环境厅
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">河南鑫泰能源有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">预算金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">40万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">开标日期</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">2024-12-05</span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">国家电投集团安徽电力有限公司2024年第20批招标（涡阳公司、淮南公司分布式光伏项目维护服务）招标公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">合肥市</span><span
															data-v-06a7ce78="" class="tag-item grey">能源化工</span><span
															data-v-06a7ce78="" class="tag-item grey">招标</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">系统平台、视频监控等<span
														class="highlight-text-orange-bd">智能化</span>管理手段，借助信息化管理平台，实现对所属电站统一远程监视、生产调度指挥，监督、指导、协调等安全生产运营相关的所有工作。
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">国家电投集团安徽电力有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">中铁上海工程局集团第三工程有限公司榆林桥畔三期安置房工程总承包联合体项目智慧工地材料竞争性谈判采购谈判公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">合肥市</span><span
															data-v-06a7ce78="" class="tag-item grey">政府办</span><span
															data-v-06a7ce78="" class="tag-item grey">竞谈</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">营业执照，具备电子与<span
														class="highlight-text-orange-bd">智能化</span>专业承包资质且具备有效期内的安全生产许可证
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">合肥市包河经济开发区管理委员会</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">开标日期</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">2024-12-09</span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span data-v-06a7ce78="">大亚湾科创·惠州软件园弱电<span
																class="highlight-text-orange-bd">智能化</span>工程施工评标过程及结果公示</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">惠州市</span><span
															data-v-06a7ce78="" class="tag-item grey">建筑业</span><span
															data-v-06a7ce78="" class="tag-item grey">成交</span><span
															data-v-06a7ce78="" class="tag-item grey">1193.37万元</span>
													</div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">科创·惠州软件园弱电<span
														class="highlight-text-orange-bd">智能化</span>工程施工评标过程及结果公示
													投资项目代码2301-441303-04-01-287722投资项目名称大亚湾科创·惠州软件园招标项目名称大亚湾科创·惠州软件园弱电<span
														class="highlight-text-orange-bd">智能化</span>工程施工标段（包）名称/公示名称大亚湾科创
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">惠州市东江建筑安装工程有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">中标金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">1193.37万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">开标日期</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">2024-11-14</span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">11月追加采购广播系统升级配件项目公告</span><!----></div>
													<!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">临汾市</span><span data-v-06a7ce78=""
															class="tag-item grey">招标</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">180413北路智控<span
														class="highlight-text-orange-bd">智能化</span>安全数字广播系统软件</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">采购单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text highlight-text"><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="buyer-item link-clickable"></span></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">开标日期</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">2024-11-30</span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">济阳同德街北租赁住房项目施工总承包中标公告</span><!----></div>
													<!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">济南市</span><span data-v-06a7ce78=""
															class="tag-item grey">交通</span><span data-v-06a7ce78=""
															class="tag-item grey">成交</span><span data-v-06a7ce78=""
															class="tag-item grey">3.42亿元</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">安装工程（弱电工程、<span
														class="highlight-text-orange-bd">智能化</span>工程、消防工程、给排水工程、电气工程、暖通工程、太阳能工程、电梯工程、空调通风工程等）、人防工程等施工、验收、保修、移交等全部工作内容（包括临时用水、用电及施工道路等临设）。
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">济南轨道交通集团置业有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">中标金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">3.42亿元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">开标日期</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">2024-11-25</span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">苇湖梁公司所属大基地场站智慧生产管理平台功能模块部署</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">乌鲁木齐市</span><span data-v-06a7ce78=""
															class="tag-item grey">能源化工</span><span data-v-06a7ce78=""
															class="tag-item grey">单一</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">0.数字电厂数字化、<span
														class="highlight-text-orange-bd">智能化</span>等咨询服务”。</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">新疆华电苇湖梁新能源有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">达坂城50万千瓦风电项目智慧生产管理平台功能模块部署</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">乌鲁木齐市</span><span data-v-06a7ce78=""
															class="tag-item grey">能源化工</span><span data-v-06a7ce78=""
															class="tag-item grey">单一</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">0.数字电厂数字化、<span
														class="highlight-text-orange-bd">智能化</span>等咨询服务”。</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">新疆华电苇湖梁新能源有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">中国铁塔股份有限公司南通市分公司MHLT智慧安防项目比选公告</span><!---->
													</div><!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
															data-v-06a7ce78=""
															class="tag-item title-file main">有附件</span><span
															data-v-06a7ce78="" class="tag-item grey">南通市</span><span
															data-v-06a7ce78="" class="tag-item grey">电信行业</span><span
															data-v-06a7ce78="" class="tag-item grey">招标</span><span
															data-v-06a7ce78="" class="tag-item grey">92.2万元</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">级及以上资质或电子与<span
														class="highlight-text-orange-bd">智能化</span>工程专业承包二级及以上资质或建筑机电工程专业承包乙级及以上资质。
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">中国铁塔股份有限公司南通市分公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">预算金额</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">92.2万元</span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">开标日期</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text">2024-12-09</span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
											<section data-v-06a7ce78="" data-v-401607c8=""
												class="project-cell cell-clickable list-item colorful-cell jy-hairline--bottom">
												<div data-v-06a7ce78="" class="title-group">
													<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5">
														<!----><span
															data-v-06a7ce78="">际华3515缝帮转车生产线设备项目采购公告</span><!----></div>
													<!---->
												</div>
												<div data-v-06a7ce78="" class="info-group">
													<div data-v-06a7ce78="" class="tag-group">
														<!----><!----><!----><!----><span data-v-06a7ce78=""
															class="tag-item grey">漯河市</span><span data-v-06a7ce78=""
															class="tag-item grey">招标</span></div>
												</div>
												<div data-v-06a7ce78="" class="detail van-ellipsis">设备选择、维护保养、<span
														class="highlight-text-orange-bd">智能化</span>控制、安全保护和故障报警等先进，运作顺畅。通过采取有效的保障措施，可以确保设备的高效、稳定运行，提高生产效率和产品质量。
												</div>
												<div data-v-06a7ce78="" class="more-detail detail-list"
													style="display: none;">
													<div data-v-06a7ce78="" class="detail-item"><span data-v-06a7ce78=""
															class="detail-label">采购单位</span><span data-v-06a7ce78=""
															class="detail-splitter">：</span><span data-v-06a7ce78=""
															class="detail-text highlight-text"><span data-v-401607c8=""
																data-v-06a7ce78=""
																class="buyer-item link-clickable">际华三五一五皮革皮鞋有限公司</span></span>
													</div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">预算金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">代理机构</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标单位</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">中标金额</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">报名截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">投标截止日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
													<div data-v-06a7ce78="" class="detail-item" style="display: none;">
														<span data-v-06a7ce78="" class="detail-label">开标日期</span><span
															data-v-06a7ce78="" class="detail-splitter">：</span><span
															data-v-06a7ce78="" class="detail-text"></span></div>
												</div>
												<div data-v-06a7ce78="" class="footer-container"><span
														data-v-06a7ce78="" class="tag-item--time">2024-11-30</span>
													<div data-v-06a7ce78="" class="title-icon">
														<div data-v-401607c8="" data-v-06a7ce78=""><span
																data-v-401607c8="" data-v-06a7ce78=""
																class="j-icon icon-star-streak"></span><span
																data-v-401607c8="" data-v-06a7ce78="">&nbsp;收藏</span>
														</div>
													</div>
												</div>
											</section>
										</div><!---->
										<div data-v-2f3156df="" data-v-401607c8="" class="empty-container"
											style="display: none;">
											<div data-v-2f3156df="" class="empty-content-position">
												<div data-v-2f3156df="" class="image empty-back"></div>
												<div data-v-2f3156df="" class="empty-main tip-text">
													<div data-v-401607c8="" data-v-2f3156df="" class="empty-text">
														对不起，没有找到<span class="highlight-text"> 近1年
														</span>相关匹配的信息，修改时间范围或换个搜索词试试吧</div><button data-v-401607c8=""
														data-v-2f3156df=""
														class="feedback-button van-button van-button--primary van-button--small van-button--plain">
														<div data-v-401607c8="" data-v-2f3156df=""
															class="van-button__content"><span data-v-401607c8=""
																data-v-2f3156df="" class="van-button__text"> 意见反馈
															</span></div>
													</button>
												</div>
											</div>
										</div>
										<div class="van-list__placeholder"></div>
									</div>
									<div data-v-401607c8="" class="table-container calc-height-1px"
										style="display: none;">
										<div data-v-401607c8="" class="scroll" style="">
											<table data-v-401607c8="" class="table">
												<tr data-v-401607c8="" class="table-header"><!---->
													<td data-v-401607c8="">项目名称</td>
													<td data-v-401607c8="">公告类型</td><!----><!----><!---->
													<td data-v-401607c8="">预算（万元）</td>
													<td data-v-401607c8="">招标单位</td>
													<td data-v-401607c8="">开标时间</td>
													<td data-v-401607c8="">中标单位</td>
													<td data-v-401607c8="">中标金额<br data-v-401607c8="">（万元）</td>
													<td data-v-401607c8="">发布时间</td>
												</tr>
												<tr data-v-401607c8="" class="table-content-tr"><!---->
													<td data-v-401607c8="">招商三亚深海装备产业园二期项目3号、6号楼<span
															class="highlight-text-orange-bd">智能化</span>工程</td>
													<td data-v-401607c8=""> 单一公告 </td><!----><!----><!---->
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> 招商（三亚）深海装备产业园有限公司 </td>
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> 深圳招商建筑科技有限公司 </td>
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> 2024-12-01 </td>
												</tr>
												<tr data-v-401607c8="" class="table-content-tr"><!---->
													<td data-v-401607c8="">随县水利和湖泊局本级鄂北地区水资源配置工程随县配套工程电子及<span
															class="highlight-text-orange-bd">智能化</span>安装工程竞争性磋商公告</td>
													<td data-v-401607c8=""> 竞谈公告 </td><!----><!----><!---->
													<td data-v-401607c8=""> 256 </td>
													<td data-v-401607c8=""> 随县水利和湖泊局 </td>
													<td data-v-401607c8=""> 2024-12-13 09:30:00 </td>
													<td data-v-401607c8=""> </td>
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> 2024-12-01 </td>
												</tr>
												<tr data-v-401607c8="" class="table-content-tr"><!---->
													<td data-v-401607c8="">在役管道抢修全自动焊<span
															class="highlight-text-orange-bd">智能化</span>技术研究11月物资需求-检测器-非招标候选人公示
													</td>
													<td data-v-401607c8=""> 中标公告 </td><!----><!----><!---->
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> 经营财务部 </td>
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> 武汉建生焊接工程有限公司 </td>
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> 2024-12-01 </td>
												</tr>
												<tr data-v-401607c8="" class="table-content-tr visited"><!---->
													<td data-v-401607c8="">沙坡头区淡水鱼养殖、牧草种植生态循环全产业链示范项目三标段（EPC）总承包招标公告
													</td>
													<td data-v-401607c8=""> 招标公告 </td><!----><!----><!---->
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> 中城生态农业科技（宁夏）有限公司 </td>
													<td data-v-401607c8=""> 2024-12-22 09:00:00 </td>
													<td data-v-401607c8=""> </td>
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> 2024-12-01 </td>
												</tr>
												<tr data-v-401607c8="" class="table-content-tr"><!---->
													<td data-v-401607c8="">沙坡头区淡水鱼养殖、牧草种植生态循环全产业链示范项目三标段（EPC）总承包)招标公告
													</td>
													<td data-v-401607c8=""> 招标公告 </td><!----><!----><!---->
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> 中城生态农业科技（宁夏）有限公司 </td>
													<td data-v-401607c8=""> 2024-12-21 09:00:00 </td>
													<td data-v-401607c8=""> </td>
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> 2024-12-01 </td>
												</tr>
												<tr data-v-401607c8="" class="table-content-tr"><!---->
													<td data-v-401607c8="">盂县第一中学校初中部教室<span
															class="highlight-text-orange-bd">智能化</span>巡课系统设备项目的更正公告
													</td>
													<td data-v-401607c8=""> 变更公告 </td><!----><!----><!---->
													<td data-v-401607c8=""> 46.9 </td>
													<td data-v-401607c8=""> 盂县第一中学校 </td>
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> </td>
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> 2024-12-01 </td>
												</tr>
												<tr data-v-401607c8="" class="table-content-tr"><!---->
													<td data-v-401607c8="">北京大学第三医院秦皇岛医院配套基础设施项目信息化建设监理招标公告</td>
													<td data-v-401607c8=""> 招标公告 </td><!----><!----><!---->
													<td data-v-401607c8=""> 191.87 </td>
													<td data-v-401607c8=""> 秦皇岛市卫生健康委员会 </td>
													<td data-v-401607c8=""> 2024-12-24 09:00:00 </td>
													<td data-v-401607c8=""> </td>
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> 2024-12-01 </td>
												</tr>
												<tr data-v-401607c8="" class="table-content-tr"><!---->
													<td data-v-401607c8="">厦门市湖里区2024P08地块及配套工程（施工“评定分离”）</td>
													<td data-v-401607c8=""> 招标公告 </td><!----><!----><!---->
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> 厦门兆元盛房地产开发有限公司 </td>
													<td data-v-401607c8=""> 2024-12-23 10:15:00 </td>
													<td data-v-401607c8=""> </td>
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> 2024-12-01 </td>
												</tr>
												<tr data-v-401607c8="" class="table-content-tr"><!---->
													<td data-v-401607c8="">中国电信股份有限公司无锡分公司宜兴市中学综合楼<span
															class="highlight-text-orange-bd">智能化</span>项目询比结果公示</td>
													<td data-v-401607c8=""> 成交公告 </td><!----><!----><!---->
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> 中国电信股份有限公司无锡分公司 </td>
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> 江苏新喜信息科技有限公司 </td>
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> 2024-12-01 </td>
												</tr>
												<tr data-v-401607c8="" class="table-content-tr"><!---->
													<td data-v-401607c8="">中海油项目部-弱电<span
															class="highlight-text-orange-bd">智能化</span>专业分包工程-公开招标项目公告
													</td>
													<td data-v-401607c8=""> 招标公告 </td><!----><!----><!---->
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> 中化学建设（海南）有限公司 </td>
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> </td>
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> 2024-12-01 </td>
												</tr>
												<tr data-v-401607c8="" class="table-content-tr"><!---->
													<td data-v-401607c8="">中电鸿信信息科技有限公司两高某小区系统集成项目（ICT）询比公告</td>
													<td data-v-401607c8=""> 询价公告 </td><!----><!----><!---->
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> 中电鸿信信息科技有限公司 </td>
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> </td>
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> 2024-12-01 </td>
												</tr>
												<tr data-v-401607c8="" class="table-content-tr"><!---->
													<td data-v-401607c8="">霍尔果斯经济开发区伊宁园区<span
															class="highlight-text-orange-bd">智能化</span>管理创业标准化厂房二期建设项目配套附属工程（EPC）[招标计划]
													</td>
													<td data-v-401607c8=""> 采购意向公告 </td><!----><!----><!---->
													<td data-v-401607c8=""> 1500 </td>
													<td data-v-401607c8=""> 霍尔果斯和祥建设投资有限公司 </td>
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> </td>
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> 2024-12-01 </td>
												</tr>
												<tr data-v-401607c8="" class="table-content-tr"><!---->
													<td data-v-401607c8="">沈阳药科大学国家药物创新综合性平台检验检测中心扩大技术装备更新改造项目（十四）招标公告
													</td>
													<td data-v-401607c8=""> 招标公告 </td><!----><!----><!---->
													<td data-v-401607c8=""> 275 </td>
													<td data-v-401607c8=""> 沈阳药科大学 </td>
													<td data-v-401607c8=""> 2024-12-22 09:00:00 </td>
													<td data-v-401607c8=""> </td>
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> 2024-12-01 </td>
												</tr>
												<tr data-v-401607c8="" class="table-content-tr"><!---->
													<td data-v-401607c8="">济南护理职业学院电子班牌指纹门禁（教学<span
															class="highlight-text-orange-bd">智能化</span>设备）采购项目--电子班牌指纹门禁
													</td>
													<td data-v-401607c8=""> 成交公告 </td><!----><!----><!---->
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> 济南护理职业学院 </td>
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> 济南腾泽信息技术有限公司 </td>
													<td data-v-401607c8=""> 2.98 </td>
													<td data-v-401607c8=""> 2024-12-01 </td>
												</tr>
												<tr data-v-401607c8="" class="table-content-tr"><!---->
													<td data-v-401607c8="">中电鸿信信息科技有限公司（泰州）两高某客户监控<span
															class="highlight-text-orange-bd">智能化</span>项目询比公告</td>
													<td data-v-401607c8=""> 询价公告 </td><!----><!----><!---->
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> 中电鸿信信息科技有限公司 </td>
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> </td>
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> 2024-12-01 </td>
												</tr>
												<tr data-v-401607c8="" class="table-content-tr"><!---->
													<td data-v-401607c8="">
														金义新区健康生物医药产业园配套基础设施建设项目-配套员工宿舍（保障性租赁用房）项目设计（重新招标）</td>
													<td data-v-401607c8=""> 招标公告 </td><!----><!----><!---->
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> 金华市金东区塘雅镇人民政府 </td>
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> </td>
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> 2024-12-01 </td>
												</tr>
												<tr data-v-401607c8="" class="table-content-tr"><!---->
													<td data-v-401607c8="">【福建】2024年福建公司呼叫中心基础平台升级研发工程单一来源采购公示</td>
													<td data-v-401607c8=""> 单一公告 </td><!----><!----><!---->
													<td data-v-401607c8=""> 427.51 </td>
													<td data-v-401607c8=""> 中国电信股份有限公司福建分公司 </td>
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> 中电福富信息科技有限公司 </td>
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> 2024-12-01 </td>
												</tr>
												<tr data-v-401607c8="" class="table-content-tr"><!---->
													<td data-v-401607c8="">潜江市路灯管理局潜江市城市照明<span
															class="highlight-text-orange-bd">智能化</span>节能改造项目招标公告</td>
													<td data-v-401607c8=""> 招标公告 </td><!----><!----><!---->
													<td data-v-401607c8=""> 1449.98 </td>
													<td data-v-401607c8=""> 潜江市路灯管理局 </td>
													<td data-v-401607c8=""> 2024-12-23 15:00:00 </td>
													<td data-v-401607c8=""> </td>
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> 2024-12-01 </td>
												</tr>
												<tr data-v-401607c8="" class="table-content-tr"><!---->
													<td data-v-401607c8="">河北医科大学第二医院儿科医疗中心室外工程招标计划</td>
													<td data-v-401607c8=""> 采购意向公告 </td><!----><!----><!---->
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> 河北医科大学第二医院 </td>
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> </td>
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> 2024-12-01 </td>
												</tr>
												<tr data-v-401607c8="" class="table-content-tr"><!---->
													<td data-v-401607c8="">2024年11月湖南人文科技学院弱电专业分包工程任务</td>
													<td data-v-401607c8=""> 招标公告 </td><!----><!----><!---->
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> 湖南省第三工程有限公司 </td>
													<td data-v-401607c8=""> 2024-12-20 00:00:00 </td>
													<td data-v-401607c8=""> </td>
													<td data-v-401607c8=""> - </td>
													<td data-v-401607c8=""> 2024-12-01 </td>
												</tr>
											</table>
										</div>
										<div data-v-401607c8="" class="to-look-more" style=""><button data-v-401607c8=""
												class="van-button van-button--primary van-button--small van-button--plain">
												<div data-v-401607c8="" class="van-button__content"><span
														data-v-401607c8="" class="van-button__text"> 查看更多 </span></div>
											</button></div>
										<div data-v-401607c8="" class="seat" style="display: none;"></div>
										<div data-v-2f3156df="" data-v-401607c8="" class="empty-container"
											style="display: none;">
											<div data-v-2f3156df="" class="empty-content-position">
												<div data-v-2f3156df="" class="image empty-back"></div>
												<div data-v-2f3156df="" class="empty-main tip-text">
													<div data-v-401607c8="" data-v-2f3156df="" class="empty-text">
														对不起，没有找到<span class="highlight-text"> 近1年
														</span>相关匹配的信息，修改时间范围或换个搜索词试试吧</div><button data-v-401607c8=""
														data-v-2f3156df=""
														class="feedback-button van-button van-button--primary van-button--small van-button--plain">
														<div data-v-401607c8="" data-v-2f3156df=""
															class="van-button__content"><span data-v-401607c8=""
																data-v-2f3156df="" class="van-button__text"> 意见反馈
															</span></div>
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div data-v-401607c8="" class="sub-position">
									<div data-v-401607c8="" class="sub-this-keywords" style="display: none;"><i
											data-v-991cf48f="" data-v-401607c8=""
											class="iconfont left icon-close_touming"></i>
										<div data-v-401607c8="" class="center text">如果您对以上结果满意可直接订阅</div>
										<div data-v-401607c8="" class="right action clickable"> 去订阅 <i
												data-v-991cf48f="" data-v-401607c8="" class="iconfont icon-youbian"
												style="color: rgb(42, 190, 209);"></i></div>
									</div>
								</div>
								<!--<div data-v-d282f6b2="" data-v-401607c8="" class="customer-corner" style="bottom: 18%;">
									<div data-v-d282f6b2="" class="content"><img data-v-d282f6b2=""
											src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAP4SURBVHgB7ZldThsxEIBnDC0tqoAjpG+EIsGeoAm0lXiDEwAnAE4AnIBwAsIJoE994Cdwgt20FVD1ge0NUKUiCo3dmf1pkmWdeDeu2of9pEjBsT0ztsczYwAKCgoK/iUIligduBPPXsAsIiyiEK+5iT4T0c83CpSHCnyl1PvLN84hWGJgAwLFx8SaQFiHtsI9UQA+KnUm79X21YLjwwAMZED5yF3HIbEJhoonYUOkkrtf5p0a5CSXAbzqo2NDO4BqBWygVP1WqA2/6txARjIbwMo/HxcNGjibMtkNrej+sICzBwDvqhoej8mGWxqmoS0lVqhP7B9JvFuU1axGZDagfNp0k8qz4krB7q2QNRMFyid09DD16HkXczMOZCCTAeWT5g6GztolVKJcilfbFN4VoUQDErtBC1G7nJ/ZMJzG3IDyscvX40GiOde2x8w23In70IiuHZUtWb1665yZzCHAFCF2Ei0+r3xe5RmPxj6lBeC5OtvpZtsznMLMgMkTl52v1NlGylezHps02AjRkqudbSyLZZqMNzJAoFjrakCs21A+5jMdF4oJ+90icNlkbF8DJj+4JUieUWhtg2UUyq3OvxGwwo7eb1xPA/jOxyewlWj24Q7sE87Z5U8oh3aiBdSivYV4II4EAauU/I1TAPWTfGDBzjEaRJZ2B8QIHmB6xAycjAWCJXTKt2Wh9lZKNWD6yK3Q0FnoJZRviqDfYATxRaN8Wxb5g0ZWqgEtAT2V/zNYQAUGhCK7qaxSanvqpDnT479MKa3RPBL/pxQGxEydfNqcOm0qzlh1fcqnXqNfn6zY24EoknK6nXZjhPkUVuI+YIlhsAQpR/mMqvB3MSQOSOGNu+8QvD50FP1RZ6yDJXQG+JCRFrZWqUBxIbzBJigB3Bsdh7QA5OfJpVQizYhJPUJCmhlA1ZMXfw+y01+Pc/sEfjINJ1lnYCJLtGV1os2FXp1+bMRHQqcM1a8vk42cQaKERYG4ogBnQiGqqRQe6mpmcuxr6BWNkWrlanqtrPWB6Eg8qllj5WVYST0iWt1a9DGC5+opC+SSbqz2FmJFeOKo0PC5LXx9kLu2qrFOWUrKrkKeZdHB36aa2+kly9rbaEyQGj8BejbB8ce/qm/yHurJ1JivXb65oJ3C+KaLZNWAyePmMiVd9T7dbh7I2b++c7zgkWxMbCbigp9lh60ZwCsvRsS1YXd6wYNayoOwn/V4WovE+BQWM3SnOBGUqp3Kn+fxLYuROF8KHr6nwja9xuV6obZmAEfKjOfxHJU8/EE+48/lfxyz5gPRMyGnEiWD7qlBMA/WfIBf2CT2TSWYc10QzIP1OMBMN9yK1PwP4KLqeFBQUFAQ8xtYzqqOaFnbawAAAABJRU5ErkJggg=="
											alt="">
										<p data-v-d282f6b2="">客服</p>
									</div>
								</div>-->
								<div data-v-0bf22245="" data-v-401607c8="" class="popupDataexport"><!----></div>
							</div>
						</div>
					</div>
				</div>
			
		

</template>

<script>
	import { ref } from 'vue';
	import { useRouter } from 'vue-router'; 
	export default {
		name: 'SearchPage',
		props: {
			msg: String
		},
		setup() {

			const isOpened = ref([false, false, false,false]);  // 是否固定元素
			const isBarOpened = ref(false);
			const isVisible = ref([false, false, false,false]);
			const inputValue = ref('');
				
			const toggleVisibility  = (index)  => {
					isVisible.value[index] = !isVisible.value[index];
					isBarOpened.value = !isBarOpened.value;
					isOpened.value[index] = !isOpened.value[index];
			};
			
			const router = useRouter();
			
			const goToBack = () => {
				router.back();
			};
			
			const goToContent = (id) => {
				router.push({path: '/ContentPage',query: { id: id }});
			};
			
			const goToSearch = () => {
				router.push({path: '/SearchPage',query: { keyword: inputValue.value }});
			};
			
			
			return {
				isVisible,
				isOpened,
				isBarOpened,
				toggleVisibility,
				inputValue,
				goToBack,
				goToSearch,
				goToContent,
				
			};
		},
		mounted() {
			//const router = useRouter();  // 获取 Vue Router 实例
			//const { keyword } = this.$router.query;
			this.inputValue = this.$route.query.keyword;
			console.log(this.$route.query.keyword);  // 输出查询参数 id 和 name
		}

	}
</script>

<style scoped>
	@import url('https://cdn-common.jianyu360.cn/jy_mobile/assets/layout-b8970476.css');  /* 引入远程 CSS 文件 */
	@import url('https://cdn-common.jianyu360.cn/jy_mobile/assets/index-65ed017b.css');
	@import url('https://cdn-common.jianyu360.cn/jy_mobile/assets/BidUpdate-4c4e3a53.css');
	@import url('https://cdn-common.jianyu360.cn/jy_mobile/assets/Ad-2a1ab4c4.css');
	@import url('https://cdn-common.jianyu360.cn/jy_mobile/assets/PopupLayout-734c9dd2.css');
	@import url('https://cdn-common.jianyu360.cn/jy_mobile/assets/index-468d7f12.css');
	@import url('https://cdn-common.jianyu360.cn/jy_mobile/assets/index-7bc74ed3.css');
	@import url('https://cdn-common.jianyu360.cn/jy_mobile/assets/popupDataexport-9a587008.css');
	@import url('https://cdn-common.jianyu360.cn/jy_mobile/assets/index-6ff30bfa.css');
	@import url('https://cdn-common.jianyu360.cn/jy_mobile/assets/index-0799990e.css');
	@import url('https://cdn-common.jianyu360.cn/jy_mobile/assets/filterHistoryDialog-ffba5828.css');
	@import url('https://cdn-common.jianyu360.cn/jy_mobile/assets/index-b6da2027.css');
	@import url('https://cdn-common.jianyu360.cn/jy_mobile/assets/index-b6da2027.css');
	@import url('https://cdn-common.jianyu360.cn/jy_mobile/assets/index-8ecf630b.css');
	@import url('https://cdn-common.jianyu360.cn/jy_mobile/assets/index-1ab2b926.css');
	@import url('https://cdn-common.jianyu360.cn/jy_mobile/assets/ScrollNav-6f417c1c.css');
	@import url('https://cdn-common.jianyu360.cn/jy_mobile/assets/index-e2ab76db.css');
	@import url('https://cdn-common.jianyu360.cn/jy_mobile/assets/index-ff712df7.css');
	@import url('https://cdn-common.jianyu360.cn/jy_mobile/assets/index-65ed017b.css');
</style>